(() => {
    function isOpenScrollMode() {
      return window.EeConfiguratorGallery?.isOpenScrollMode?.() ?? window.scrollY > 200;
    }

    function initSwatchConfigurator(radios) {
      if (!radios || radios.dataset.swatchInit === 'true') return;
      radios.dataset.swatchInit = 'true';
  
      const sectionId = radios.dataset.section;
      if (!sectionId) return;
  
      let lastStyleInputId = null;
  
      function getById(id) {
        return document.getElementById(id);
      }
  
      function getFormEl() {
        const root = radios.closest('ee-configurator-product-info') || document;
        return root.querySelector('ee-product-form, configurator-product-form');
      }

      function dispatchAddonLayerChange() {
        try {
          document.dispatchEvent(new Event('configurator:addon-layer-change'));
        } catch (_) {}
      }

      function escAttr(val) {
        return String(val || '').replace(/"/g, '\\"');
      }

      function getCurrencyCode() {
        return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      }

      function formatCents(cents) {
        const amt = cents / 100;
        const isWhole = cents % 100 === 0;
        return amt.toLocaleString(undefined, {
          style: 'currency',
          currency: getCurrencyCode(),
          currencyDisplay: 'narrowSymbol',
          minimumFractionDigits: isWhole ? 0 : 2,
          maximumFractionDigits: isWhole ? 0 : 2,
        });
      }

      function updateCardPriceFromSwatch(card, sw) {
        if (!card || !sw) return;
        const centsStr = sw.getAttribute('data-variant-price');
        const priceCents = centsStr ? parseInt(centsStr, 10) : NaN;
        if (isNaN(priceCents)) return;

        const nodes = card.querySelectorAll('.content-wrapper > .text-lg.leading-tight');
        const priceWrap = nodes.length ? nodes[nodes.length - 1] : null;
        if (!priceWrap) return;

        try {
          const mainInputEl = card.querySelector('input[type="radio"], input[type="checkbox"]');
          const origCentsStr = mainInputEl ? mainInputEl.getAttribute('data-price') : '';
          const origCents = origCentsStr ? parseInt(origCentsStr, 10) : NaN;

          let html = `<span class="text-midnight">${formatCents(priceCents)}</span>`;
          if (!isNaN(origCents) && origCents !== priceCents) {
            html += ` <span class="text-zinc-500 line-through">${formatCents(origCents)}</span>`;
          }
          priceWrap.innerHTML = html;
        } catch (_) {
          const amt = priceCents / 100;
          const whole = priceCents % 100 === 0;
          priceWrap.innerHTML = `<span class="text-midnight">$${whole ? Math.round(amt).toLocaleString() : amt.toFixed(2)}</span>`;
        }
      }

      function syncFormSwatchContext(card, sw) {
        const formEl = getFormEl();
        if (!formEl || !sw) return;

        const vid = sw.getAttribute('data-variant-id');
        const shadeId = sw.getAttribute('data-shade-id') || '';
        const mainInputEl = card
          ? card.querySelector('input[type="radio"], input[type="checkbox"]')
          : null;
        const baseStr = mainInputEl ? mainInputEl.getAttribute('data-price') : '';
        const swatchPriceStr = sw.getAttribute('data-variant-price');
        const swatchPriceCents = swatchPriceStr ? parseInt(swatchPriceStr, 10) : NaN;

        if (!isNaN(swatchPriceCents)) {
          formEl.setAttribute('data-swatch-price-cents', String(swatchPriceCents));
        } else {
          formEl.removeAttribute('data-swatch-price-cents');
        }
        formEl.setAttribute('data-base-price-cents', baseStr || '');
        if (shadeId) formEl.setAttribute('data-shade-name', shadeId);

        if (vid) {
          const info =
            radios.closest('ee-configurator-product-info') ||
            document.querySelector('ee-configurator-product-info');

          if (info?.updateVariantInput) {
            info.updateVariantInput(String(vid));
          } else if (window.EeConfiguratorVariantSync && formEl) {
            const form = formEl.querySelector('form');
            if (form) window.EeConfiguratorVariantSync.syncMainVariantInputs(form, vid);
          }

          if (info) {
            const variantsScript = radios.querySelector('script[data-product-variants]');
            if (variantsScript) {
              try {
                const variants = JSON.parse(variantsScript.textContent || '[]');
                const matched = variants.find((v) => String(v.id) === String(vid));
                if (matched) {
                  info.dispatchVariantChangeEvent(matched);
                }
              } catch (_) {}
            }
          } else {
            try {
              const url = new URL(window.location.href);
              url.searchParams.set('variant', String(vid));
              history.replaceState({}, '', url.toString());
            } catch (_) {}
          }

          if (window.eeConfiguratorCompulsory?.applyForVariant) {
            window.eeConfiguratorCompulsory.applyForVariant(String(vid));
          }
        }
      }
  
      const SUB_PART_SWATCH = '[data-subpart-swatch]';

      function getProductInfo() {
        return (
          radios.closest('ee-configurator-product-info') ||
          document.querySelector('ee-configurator-product-info')
        );
      }

      function findVariantById(variantId) {
        const variantsScript = radios.querySelector('script[data-product-variants]');
        if (!variantsScript) return null;
        try {
          const variants = JSON.parse(variantsScript.textContent || '[]');
          return variants.find((v) => String(v.id) === String(variantId)) || null;
        } catch (_) {
          return null;
        }
      }

      function restoreSubPartCard(card) {
        if (!card) return;

        const titleEl =
          card.querySelector('[data-config-title]') ||
          card.querySelector('.content-wrapper > .font-normal.text-lg');
        if (titleEl && titleEl.hasAttribute('data-subpart-original-title')) {
          titleEl.textContent = titleEl.getAttribute('data-subpart-original-title');
          titleEl.removeAttribute('data-subpart-original-title');
        }

        const priceEl = card.querySelector('[data-config-price]');
        if (priceEl && priceEl.hasAttribute('data-subpart-original-price')) {
          priceEl.innerHTML = priceEl.getAttribute('data-subpart-original-price');
          priceEl.removeAttribute('data-subpart-original-price');
        }

        const tagEl = card.querySelector('[data-config-tag]');
        if (tagEl && tagEl.hasAttribute('data-subpart-original-tag')) {
          try {
            const original = JSON.parse(tagEl.getAttribute('data-subpart-original-tag'));
            tagEl.innerHTML = original.html;
            tagEl.className = original.className;
            if (original.style) tagEl.setAttribute('style', original.style);
            else tagEl.removeAttribute('style');
          } catch (_) {}
          tagEl.removeAttribute('data-subpart-original-tag');
        }

        const imgEl = card.querySelector('.config-card-container img');
        if (imgEl && imgEl.hasAttribute('data-subpart-original-src')) {
          const originalSrc = imgEl.getAttribute('data-subpart-original-src');
          const originalSrcset = imgEl.getAttribute('data-subpart-original-srcset');
          const originalAlt = imgEl.getAttribute('data-subpart-original-alt');
          if (originalSrc) imgEl.setAttribute('src', originalSrc);
          if (originalSrcset) imgEl.setAttribute('srcset', originalSrcset);
          else imgEl.removeAttribute('srcset');
          if (originalAlt !== null) imgEl.setAttribute('alt', originalAlt);
          imgEl.removeAttribute('data-subpart-original-src');
          imgEl.removeAttribute('data-subpart-original-srcset');
          imgEl.removeAttribute('data-subpart-original-alt');
        }
      }

      function clearSubPartSelection() {
        radios.querySelectorAll(SUB_PART_SWATCH).forEach((sw) => {
          sw.classList.remove('active');
          sw.setAttribute('aria-checked', 'false');
        });
        radios.querySelectorAll('[data-subpart-swatches]').forEach((wrapper) => {
          restoreSubPartCard(wrapper.closest('.add-on-wrapper-flex'));
        });
      }

      function applySubPartToCard(card, sw) {
        if (!card || !sw) return;

        card.querySelectorAll(SUB_PART_SWATCH).forEach((el) => {
          el.classList.remove('active');
          el.setAttribute('aria-checked', 'false');
        });
        sw.classList.add('active');
        sw.setAttribute('aria-checked', 'true');

        const displayTitle =
          (sw.getAttribute('data-display-title') ||
            sw.getAttribute('title') ||
            sw.getAttribute('aria-label') ||
            sw.getAttribute('data-option-value') ||
            '').trim();
        const titleEl =
          card.querySelector('[data-config-title]') ||
          card.querySelector('.content-wrapper > .font-normal.text-lg');
        if (titleEl && displayTitle) {
          if (!titleEl.hasAttribute('data-subpart-original-title')) {
            titleEl.setAttribute('data-subpart-original-title', titleEl.textContent || '');
          }
          titleEl.textContent = displayTitle;
        }

        const priceHtml = sw.getAttribute('data-price-html');
        const priceEl = card.querySelector('[data-config-price]');
        if (priceEl && priceHtml) {
          if (!priceEl.hasAttribute('data-subpart-original-price')) {
            priceEl.setAttribute('data-subpart-original-price', priceEl.innerHTML);
          }
          priceEl.innerHTML = priceHtml;
        }

        const tagEl = card.querySelector('[data-config-tag]');
        if (tagEl) {
          if (!tagEl.hasAttribute('data-subpart-original-tag')) {
            tagEl.setAttribute(
              'data-subpart-original-tag',
              JSON.stringify({
                html: tagEl.innerHTML,
                className: tagEl.className,
                style: tagEl.getAttribute('style') || '',
              })
            );
          }
          const tagText = (sw.getAttribute('data-tag-text') || '').trim();
          const tagColor = (sw.getAttribute('data-tag-color') || '').trim();
          const soldOut = sw.getAttribute('data-available') === 'false';
          tagEl.textContent = tagText;
          tagEl.classList.toggle('hidden', !tagText);
          tagEl.classList.remove('bg-rose-bud', '!bg-red-700');
          tagEl.style.removeProperty('background-color');
          if (soldOut) {
            tagEl.classList.add('!bg-red-700');
          } else if (tagColor) {
            tagEl.style.backgroundColor = tagColor;
          } else {
            tagEl.classList.add('bg-rose-bud');
          }
        }

        const cardImage = sw.getAttribute('data-card-image');
        const imgEl = card.querySelector('.config-card-container img');
        if (cardImage && imgEl) {
          if (!imgEl.hasAttribute('data-subpart-original-src')) {
            imgEl.setAttribute('data-subpart-original-src', imgEl.getAttribute('src') || '');
            imgEl.setAttribute('data-subpart-original-srcset', imgEl.getAttribute('srcset') || '');
            imgEl.setAttribute('data-subpart-original-alt', imgEl.getAttribute('alt') || '');
          }
          imgEl.setAttribute('src', cardImage);
          imgEl.setAttribute('alt', sw.getAttribute('data-variant-title') || '');
          imgEl.removeAttribute('srcset');
        }

        const overlaySrc = imgEl ? imgEl.getAttribute('src') : '';
        if (overlaySrc) {
          setOverlay(overlaySrc, {
            isSwatch: false,
            altText: sw.getAttribute('data-variant-title') || '',
          });
        }

        selectSubPartVariant(sw.getAttribute('data-variant-id'));
      }

      function selectSubPartVariant(variantId) {
        if (!variantId) return;

        const info = getProductInfo();
        if (info?.updateVariantInput) {
          info.updateVariantInput(String(variantId));
          const matched = findVariantById(variantId);
          if (matched) info.dispatchVariantChangeEvent(matched);
        } else {
          const formEl = getFormEl();
          const form = formEl ? formEl.querySelector('form') : null;
          if (form) window.EeConfiguratorVariantSync?.syncMainVariantInputs(form, variantId);
          try {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', String(variantId));
            history.replaceState({}, '', url.toString());
          } catch (_) {}
        }

        if (window.eeConfiguratorCompulsory?.applyForVariant) {
          window.eeConfiguratorCompulsory.applyForVariant(String(variantId));
        }
      }

      function isStyleOptionInput(input) {
        if (!input) return false;
        const nm = input.getAttribute('name') || '';
        if (/color/i.test(nm) || /style/i.test(nm)) return true;
        // Fallback: cards inside the image-update style grid.
        return !!input.closest('.js-image-update');
      }

      function getStyleCardMainInput(card) {
        if (!card) return null;
        // Style cards use radios; add-on cards use checkboxes — ignore those.
        if (card.querySelector('input[type="checkbox"][data-product-id], input[type="checkbox"][name^="addon-"]')) {
          return null;
        }
        const input = card.querySelector('.config-card-container input[type="radio"]');
        return isStyleOptionInput(input) ? input : null;
      }

      function cardHasActiveSubPart(card) {
        return !!(card && card.querySelector(`${SUB_PART_SWATCH}.active`));
      }

      /**
       * Re-select the parent style variant after leaving a sub-part (e.g. White Oak → White Shaker).
       * clearSubPartSelection only restores card chrome; this restores the real variant id so
       * add-on layers (crown, etc.) rematch the parent.
       */
      function restoreParentVariantFromCard(card) {
        const mainInput = getStyleCardMainInput(card);
        if (!mainInput) return false;
        const variantId = mainInput.getAttribute('data-variant-id');
        if (!variantId || !/^\d+$/.test(String(variantId))) return false;
        selectSubPartVariant(variantId);
        return true;
      }

      /**
       * Parent card re-click while a sub-part is active: radio is already checked so no change
       * event fires (clicks hit the label). Clear sub-part UI + restore parent variant.
       */
      function handleParentStyleCardReselect(card) {
        if (!card || !cardHasActiveSubPart(card)) return false;

        const mainInput = getStyleCardMainInput(card);
        if (!mainInput) return false;

        clearShadeSelection();
        clearSubPartSelection();
        if (!mainInput.checked) mainInput.checked = true;
        lastStyleInputId = mainInput.id ? String(mainInput.id) : lastStyleInputId;
        restoreParentVariantFromCard(card);

        setTimeout(() => {
          apply();
          dispatchAddonLayerChange();
        }, 0);
        return true;
      }

      function handleSubPartActivate(sw) {
        if (sw.classList.contains('disabled') || sw.getAttribute('aria-disabled') === 'true') return;

        const card = sw.closest('.add-on-wrapper-flex');
        if (!card) return;

        const mainInput = card.querySelector('input[type="radio"]');
        if (mainInput && !mainInput.checked) {
          mainInput.checked = true;
          mainInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        lastStyleInputId = mainInput && mainInput.id ? String(mainInput.id) : lastStyleInputId;

        // Runs after the change-driven handlers so the card override is not immediately reset.
        setTimeout(() => {
          clearSubPartSelection();
          applySubPartToCard(card, sw);
          dispatchAddonLayerChange();
        }, 0);
      }

      function getInitialVariantId() {
        try {
          const fromUrl = new URLSearchParams(window.location.search).get('variant');
          if (fromUrl) return fromUrl;
        } catch (_) {}

        const selectedScript = radios.querySelector('script[data-selected-variant]');
        if (!selectedScript) return null;
        try {
          const selected = JSON.parse(selectedScript.textContent || '{}');
          return selected?.id ? String(selected.id) : null;
        } catch (_) {
          return null;
        }
      }

      function applyInitialSubPart() {
        const variantId = getInitialVariantId();
        if (!variantId) return;

        const sw = radios.querySelector(
          `${SUB_PART_SWATCH}[data-variant-id="${escAttr(variantId)}"]`
        );
        if (!sw) return;

        const card = sw.closest('.add-on-wrapper-flex');
        if (!card) return;

        const mainInput = card.querySelector('input[type="radio"]');
        if (mainInput) mainInput.checked = true;
        highlightSelected();
        applySubPartToCard(card, sw);
      }

      function getSelectedStyleContext() {
        let styleFs = null;
        radios.querySelectorAll('fieldset').forEach((fs) => {
          if (styleFs) return;
          const anyInput = fs.querySelector('input[type="radio"]');
          if (!anyInput) return;
          const nm = anyInput.getAttribute('name') || '';
          if (/color/i.test(nm) || /style/i.test(nm)) styleFs = fs;
        });
        if (!styleFs) {
          const styleGrid = radios.querySelector('.js-image-update');
          if (styleGrid) styleFs = styleGrid.closest('fieldset');
        }
        const checkedStyle =
          (styleFs && styleFs.querySelector('input[type="radio"]:checked')) ||
          radios.querySelector('input[type="radio"]:checked');
        const selectedCard = checkedStyle ? checkedStyle.closest('.add-on-wrapper-flex') : null;
        return {
          selectedCard,
          isTargeted: !!(selectedCard && selectedCard.querySelector('.variant_swatches_radio')),
          styleInput: checkedStyle,
        };
      }
  
      function restoreMainGalleryImage() {
        const galleryList = getById(`Slider-Gallery-${sectionId}`);
        if (!galleryList) return;
        const mutated = galleryList.querySelectorAll('img[data-swatch-original-src]');
        if (!mutated.length) return;
        mutated.forEach((img) => {
          const originalSrc = img.getAttribute('data-swatch-original-src');
          const originalSrcset = img.getAttribute('data-swatch-original-srcset');
          if (originalSrc) img.src = originalSrc;
          if (originalSrcset) img.setAttribute('srcset', originalSrcset);
          else img.removeAttribute('srcset');
          img.removeAttribute('data-swatch-original-src');
          img.removeAttribute('data-swatch-original-srcset');
        });
      }
  
      function updateMainGalleryImage(url) {
        if (!url) return;
        const galleryList = getById(`Slider-Gallery-${sectionId}`);
        if (!galleryList) return;
        const activeSlide =
          galleryList.querySelector('li.product__media-item.grid__item.slider__slide.is-active:not([data-add-on-media-id])') ||
          galleryList.querySelector('li.product__media-item.grid__item.slider__slide.is-active');
        if (!activeSlide) return;
        const activeImg = activeSlide.querySelector('img');
        if (!activeImg) return;
        if (!activeImg.getAttribute('data-swatch-original-src')) {
          activeImg.setAttribute('data-swatch-original-src', activeImg.currentSrc || activeImg.getAttribute('src') || '');
          activeImg.setAttribute('data-swatch-original-srcset', activeImg.getAttribute('srcset') || '');
        }
        activeImg.src = url;
        activeImg.removeAttribute('srcset');
      }
  
      function setOverlay(url, opts) {
        opts = opts || {};
        const cont = getById(`VariantOverlay-${sectionId}`);
        const img = getById(`VariantOverlayImg-${sectionId}`);
        const galleryViewer = getById(`GalleryViewer-${sectionId}`);
        if (!cont || !img) return;
        const allowOpenState = !!opts.allowOpenState;
        const isSwatchOverlay = !!opts.isSwatch;
  
        if (url) {
          img.src = url;
          const altText = opts.altText || '';
          if (altText) img.setAttribute('alt', altText);
          if (allowOpenState) cont.setAttribute('data-open-state-overlay', 'true');
          else cont.removeAttribute('data-open-state-overlay');
          if (isSwatchOverlay) {
            cont.setAttribute('data-swatch-overlay', 'true');
          } else {
            cont.removeAttribute('data-swatch-overlay');
          }
          if (isOpenScrollMode() && !allowOpenState) cont.classList.remove('visible');
          else cont.classList.add('visible');
          syncVariantOverlayStack();
        } else {
          img.removeAttribute('src');
          cont.classList.remove('visible');
          cont.removeAttribute('data-open-state-overlay');
          cont.removeAttribute('data-swatch-overlay');
          syncVariantOverlayStack();
        }
      }
  
      function syncVariantOverlayStack() {
        const overlayCont = getById(`VariantOverlay-${sectionId}`);
        const galleryViewer = getById(`GalleryViewer-${sectionId}`);
        const img = getById(`VariantOverlayImg-${sectionId}`);
        if (!overlayCont || !galleryViewer) return;

        const hasSrc = !!(img && img.getAttribute('src'));
        const isSwatch = overlayCont.getAttribute('data-swatch-overlay') === 'true';

        if (isOpenScrollMode()) {
          if (
            overlayCont.getAttribute('data-open-state-overlay') === 'true' &&
            hasSrc &&
            isSwatch
          ) {
            galleryViewer.classList.add('swatch-overlay-active');
          } else {
            galleryViewer.classList.remove('swatch-overlay-active');
          }
        } else if (isSwatch && hasSrc && overlayCont.classList.contains('visible')) {
          galleryViewer.classList.add('swatch-overlay-active');
        } else {
          galleryViewer.classList.remove('swatch-overlay-active');
        }
        window.EeConfiguratorGallery?.requestMobileStackSync?.();
      }

      function clearOpenStateOverlay() {
        const cont = getById(`VariantOverlay-${sectionId}`);
        const galleryViewer = getById(`GalleryViewer-${sectionId}`);
        if (!cont) return;
        cont.removeAttribute('data-open-state-overlay');
        if (isOpenScrollMode()) cont.classList.remove('visible');
        cont.removeAttribute('data-swatch-overlay');
        if (galleryViewer) galleryViewer.classList.remove('swatch-overlay-active');
      }
  
      function clearShadeSelection() {
        try {
          radios.querySelectorAll('fieldset').forEach((fs) => {
            const anyInput = fs.querySelector('input[type="radio"]');
            if (!anyInput) return;
            const nm = anyInput.getAttribute('name') || '';
            if (!(/shade/i.test(nm) || /swatch/i.test(nm))) return;
            fs.querySelectorAll('input[type="radio"]').forEach((inp) => {
              inp.checked = false;
            });
          });
          radios.querySelectorAll('.variant_swatches_radio').forEach((el) => {
            el.classList.remove('active');
          });
          const formEl = getFormEl();
          if (formEl) {
            formEl.removeAttribute('data-shade-name');
            formEl.removeAttribute('data-swatch-price-cents');
          }
          const overlay = getById(`VariantOverlay-${sectionId}`);
          if (overlay) overlay.removeAttribute('data-open-state-overlay');
          restoreMainGalleryImage();
          dispatchAddonLayerChange();
        } catch (_) {}
      }

      function getSwatchTargets() {
        const targets = [];
        try {
          const rawList = radios.getAttribute('data-swatch-targets') || '';
          const parsed = JSON.parse(rawList);
          if (Array.isArray(parsed)) {
            targets.push(
              ...parsed.map((x) => String(x || '').toLowerCase()).filter(Boolean)
            );
          } else if (parsed && typeof parsed === 'string') {
            targets.push(parsed.toLowerCase());
          }
        } catch (_) {}
        return targets;
      }
  
      function highlightSelected() {
        try {
          let styleFs = null;
          radios.querySelectorAll('fieldset').forEach((fs) => {
            if (styleFs) return;
            const anyInput = fs.querySelector('input[type="radio"]');
            if (!anyInput) return;
            const nm = anyInput.getAttribute('name') || '';
            if (/color/i.test(nm) || /style/i.test(nm)) styleFs = fs;
          });
          if (!styleFs) return;

          styleFs.querySelectorAll('.add-on-wrapper-flex').forEach((card) => {
            card.classList.remove('add-border-3px');
            const cardBorder = card.querySelector('[id="configurator-card-border"]');
            if (cardBorder) cardBorder.classList.remove('add-border-3px');
          });
          const checkedStyle = styleFs.querySelector('input[type="radio"]:checked');
          const selectedCard = checkedStyle
            ? checkedStyle.closest('.add-on-wrapper-flex')
            : null;
          if (selectedCard) selectedCard.classList.add('add-border-3px');

          radios.querySelectorAll('.variant_swatches_radio').forEach((el) => {
            el.classList.remove('active');
          });

          if (!selectedCard) return;
          const mainInputEl = selectedCard.querySelector('input[type="radio"]');
          let currentHandle = null;
          if (mainInputEl && mainInputEl.id) {
            const m = String(mainInputEl.id).match(/^configurator-[^-]+-(.+)$/);
            if (m && m[1]) currentHandle = m[1].toLowerCase();
          }
          const targets = getSwatchTargets();
          const isTargeted = currentHandle && targets.indexOf(currentHandle) > -1;
          if (!isTargeted) return;

          const firstSw = selectedCard.querySelector('.variant_swatches_radio');
          if (!firstSw) return;
          const shadeOptName = firstSw.getAttribute('data-next-option-name');
          const shadeChecked = shadeOptName
            ? radios.querySelector(
                `input[type="radio"][name="${shadeOptName.replace(/"/g, '\\"')}"]:checked`
              )
            : null;
          if (!shadeChecked) return;
          const match = selectedCard.querySelector(
            `.variant_swatches_radio[data-shade-id="${shadeChecked.value.replace(/"/g, '\\"')}"]`
          );
          if (match) match.classList.add('active');
        } catch (_) {}
      }
  
      function apply() {
        highlightSelected();
        try {
          const styleCtx = getSelectedStyleContext();
          const selectedCard = styleCtx.selectedCard;
          if (!selectedCard) {
            dispatchAddonLayerChange();
            return;
          }
  
          const styleInputId = styleCtx.styleInput && styleCtx.styleInput.id ? String(styleCtx.styleInput.id) : '';
          if (styleInputId !== lastStyleInputId) {
            lastStyleInputId = styleInputId;
            clearShadeSelection();
            clearSubPartSelection();
          }
  
          const formMode = getFormEl();
          if (formMode) {
            formMode.setAttribute('data-swatch-targeted', styleCtx.isTargeted ? 'true' : 'false');
            if (!styleCtx.isTargeted) {
              formMode.removeAttribute('data-shade-name');
              if (isOpenScrollMode()) clearOpenStateOverlay();
            }
          }
  
          const cardImg = selectedCard.querySelector('img');
          const overlayCont = getById(`VariantOverlay-${sectionId}`);
          const keepOpenSwatchOverlay =
            isOpenScrollMode() &&
            overlayCont &&
            overlayCont.getAttribute('data-open-state-overlay') === 'true';
          if (!keepOpenSwatchOverlay && cardImg && cardImg.src) {
            setOverlay(cardImg.src, { isSwatch: styleCtx.isTargeted });
          } else if (!keepOpenSwatchOverlay) {
            const gv = getById(`GalleryViewer-${sectionId}`);
            if (gv) gv.classList.remove('swatch-overlay-active');
          }
        } catch (_) {}
        finally {
          dispatchAddonLayerChange();
          syncVariantOverlayStack();
        }
      }
  
      function applyShadeToSelectedCard() {
        try {
          const styleCtx = getSelectedStyleContext();
          const selectedCard = styleCtx.selectedCard;
          if (!selectedCard) return;
  
          const formMode = getFormEl();
          if (formMode) formMode.setAttribute('data-swatch-targeted', styleCtx.isTargeted ? 'true' : 'false');
          if (!styleCtx.isTargeted) {
            if (formMode) formMode.removeAttribute('data-shade-name');
            if (isOpenScrollMode()) clearOpenStateOverlay();
            return;
          }
  
          let shadeFs = null;
          let shadeVal = '';
          radios.querySelectorAll('fieldset').forEach((fs) => {
            if (shadeFs) return;
            const anyInput = fs.querySelector('input[type="radio"]');
            if (!anyInput) return;
            const nm = anyInput.getAttribute('name') || '';
            if (/shade/i.test(nm) || /swatch/i.test(nm)) shadeFs = fs;
          });
          if (shadeFs) {
            const checkedShade = shadeFs.querySelector('input[type="radio"]:checked');
            if (checkedShade) shadeVal = checkedShade.value;
          }
          if (!shadeVal) {
            if (formMode) formMode.removeAttribute('data-shade-name');
            restoreMainGalleryImage();
            if (isOpenScrollMode()) clearOpenStateOverlay();
            return;
          }
  
          const sw = selectedCard.querySelector(`.variant_swatches_radio[data-shade-id="${shadeVal.replace(/"/g, '\\"')}"]`);
          if (!sw) {
            restoreMainGalleryImage();
            if (isOpenScrollMode()) clearOpenStateOverlay();
            return;
          }
  
          const swWrap = sw.closest('.ws-color_swatch_wrapper') || selectedCard;
          if (swWrap) {
            swWrap.querySelectorAll('.variant_swatches_radio').forEach((el) => {
              el.classList.remove('active');
            });
          }
          sw.classList.add('active');
  
          if (formMode && shadeVal) formMode.setAttribute('data-shade-name', shadeVal);

          updateCardPriceFromSwatch(selectedCard, sw);
          syncFormSwatchContext(selectedCard, sw);

          const imgUrl = sw.getAttribute('data-variant-image');
          const openStateImg = sw.getAttribute('data-swatch-open-image');
          if (imgUrl) {
            const cardImg = selectedCard.querySelector('img');
            if (cardImg && cardImg.getAttribute('data-meta-button-image') !== 'true') cardImg.src = imgUrl;
            updateMainGalleryImage(imgUrl);
          }
  
          const swAlt = sw.getAttribute('data-variant-title') || shadeVal || '';
          if (isOpenScrollMode() && openStateImg) {
            setOverlay(openStateImg, { allowOpenState: true, isSwatch: true, altText: swAlt });
          } else if (isOpenScrollMode()) {
            clearOpenStateOverlay();
          } else if (imgUrl) {
            setOverlay(imgUrl, { isSwatch: true, altText: swAlt });
          }
        } catch (_) {}
        finally {
          dispatchAddonLayerChange();
          syncVariantOverlayStack();
        }
      }

      radios.addEventListener('change', () => {
        apply();
        setTimeout(applyShadeToSelectedCard, 0);
      });

      radios.addEventListener('ee-variant-change', () => {
        setTimeout(() => {
          apply();
          applyShadeToSelectedCard();
        }, 0);
      });
  
      radios.addEventListener('click', (e) => {
        const target = e.target;
        if (!target || !target.closest) return;

        // Don't steal clicks from learn-more / modal / links.
        if (target.closest('button, a, modal-opener, modal-dialog, [data-modal]')) return;

        const subPartSw = target.closest(SUB_PART_SWATCH);
        if (subPartSw) {
          handleSubPartActivate(subPartSw);
          return;
        }

        const sw = target.closest('.variant_swatches_radio');
        if (sw) {
          if (sw.classList.contains('disabled') || sw.getAttribute('aria-disabled') === 'true') return;

          const card = sw.closest('.add-on-wrapper-flex');
          if (card) {
            const mainInput = card.querySelector('input[type="radio"]');
            if (mainInput && !mainInput.checked) {
              mainInput.checked = true;
              mainInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }

          const oname = sw.getAttribute('data-next-option-name');
          const oval = sw.getAttribute('data-shade-id');
          if (oname && oval) {
            const selector = `input[type="radio"][name="${escAttr(oname)}"][value="${escAttr(oval)}"]`;
            const shadeTarget = radios.querySelector(selector);
            if (shadeTarget && !shadeTarget.checked) {
              shadeTarget.checked = true;
              shadeTarget.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }

          setTimeout(applyShadeToSelectedCard, 0);
          return;
        }

        // Style card click (usually the label over an already-checked radio when returning
        // from a sub-part like White Oak → White Shaker).
        const styleCard = target.closest('.add-on-wrapper-flex');
        const styleInput = getStyleCardMainInput(styleCard);
        if (!styleInput) return;

        if (handleParentStyleCardReselect(styleCard)) return;

        // Switching to a different style card (or first selecting this one).
        if (styleInput.closest('.add-on-wrapper-flex')) {
          const hadActiveSubPart = !!radios.querySelector(`${SUB_PART_SWATCH}.active`);
          if (hadActiveSubPart) clearSubPartSelection();
          clearShadeSelection();
          lastStyleInputId = styleInput.id ? String(styleInput.id) : lastStyleInputId;
          setTimeout(apply, 0);
        }
      });
  
      radios.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        const sw = e.target && e.target.closest && e.target.closest(SUB_PART_SWATCH);
        if (!sw) return;
        e.preventDefault();
        handleSubPartActivate(sw);
      });

      const thumbs = getById(`Slider-Thumbnails-${sectionId}`);
      if (thumbs) {
        thumbs.addEventListener('click', (e) => {
          const btn = e.target && e.target.closest && e.target.closest('button.thumbnail');
          if (!btn) return;
          setOverlay(null);
        });
      }
  
      let lastOverlayOpenMode = isOpenScrollMode();
      window.addEventListener(
        'scroll',
        () => {
          const cont = getById(`VariantOverlay-${sectionId}`);
          const img = getById(`VariantOverlayImg-${sectionId}`);
          if (!cont || !img) return;

          const isOpenMode = isOpenScrollMode();
          if (isOpenMode !== lastOverlayOpenMode) {
            lastOverlayOpenMode = isOpenMode;
            applyShadeToSelectedCard();
          }

          if (isOpenMode) {
            if (cont.getAttribute('data-open-state-overlay') === 'true' && img.getAttribute('src')) {
              cont.classList.add('visible');
            } else {
              cont.classList.remove('visible');
            }
          } else if (img.getAttribute('src')) {
            cont.classList.add('visible');
          }

          syncVariantOverlayStack();
        },
        { passive: true }
      );
  
      highlightSelected();
      apply();
      applyShadeToSelectedCard();
      applyInitialSubPart();
    }
  
    function boot() {
      document.querySelectorAll('ee-variant-selects[data-section]').forEach(initSwatchConfigurator);
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
})();